"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commentSchema = void 0;
const zod_1 = require("zod");
const shortField_schema_1 = require("./shortField.schema");
const longField_schema_1 = require("./longField.schema");
exports.commentSchema = zod_1.z
    .object({
    name: shortField_schema_1.shortFieldSchema,
    comment: longField_schema_1.longFieldSchema,
})
    .strict();
//# sourceMappingURL=comment.schema.js.map